import { render, staticRenderFns } from "./ProductsStepCardView.vue?vue&type=template&id=18759a8b&"
import script from "./ProductsStepCardView.vue?vue&type=script&lang=js&"
export * from "./ProductsStepCardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports